<template>
  <div class="w1200 newsBox">
    <div class="leftBox">
      <div class="topBox">
        <span class="el-icon-location" /><span class="albums" @click="goablum">专辑</span>/<span class="albums_name">{{ contentData.album.ALBUM_NAME }}</span>
      </div>
      <div class="topmsg">
        <div class="imgBox">
          <img v-if="contentData.album.ALBUM_COVER" :src="contentData.album.ALBUM_COVER" alt="">
          <img v-else :src="noimg" alt="">
        </div>
        <div class="msg_rightBox">
          <h5>{{ contentData.album.ALBUM_NAME }}</h5>
          <p>{{ contentData.album.ALBUM_TITLE }}</p>
          <span class="msg_rightBox_span">专辑类型：{{ contentData.album.ALBUM_TYPE_IDS |changeType_album }}</span>
          <span class="msg_rightBox_span">编辑：{{ contentData.album.ALBUM_EDITOR }}</span>
          <span class="msg_rightBox_span abstract">简介：<span>{{ contentData.album.ALBUM_ABSTRACT }}</span></span>
          <div class="shareBox">
            <div class="starBtn" @click="goread(0,0)">
              开始阅读
            </div>
            <span class="phoneHideBOx">
              <span>分享到:</span>
              <span class="icon" @click="weibo"><svg-icon icon-class="wb" /></span>
              <span class="icon" @click="qq"><svg-icon icon-class="qq" /></span>
              <span class="icon wxImg"><svg-icon icon-class="wx" /><div id="qrcode" ref="qrcode" /></span>
              <div class="bdsharebuttonbox moreShare">
                <a href="#" class="bds_more el-icon-more" data-cmd="more" />
              </div>
              <span class="icon icon2" @click="shareImg"><i class="el-icon-share" />生成分享图片</span></span>
            <span :class="contentData.collectionNOrNot?'collected':'nocollected'" @click="goshowcang"><svg-icon icon-class="shoucang" /></span>
            <span class="num">{{ contentData.album.COL_COUNT }}</span>
          </div>
          <div class="foot_msg">
            <span class="foot_msg_span">
              <svg-icon icon-class="shijian" /><span>{{ contentData.album.ALBUM_DATE |changeTime2 }}</span>
            </span>
            <span class="foot_msg_span">
              <svg-icon icon-class="view" /><span>{{ contentData.album.ALBUM_READING_SIZE }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="muluBox">
        <div class="topname">
          <span>目录</span>
        </div>
        <Mulu :list="contentData.catalogTree" :album-id="albumId" />
      </div>
      <div class="tuijian">
        <div class="Booktitle">
          <span>推荐家谱</span>
        </div>
        <tuijianBook />
      </div>
      <div class="youlike">
        <div class="topname">
          <span>猜你喜欢</span>
        </div>
        <div v-for="item in likeData" :key="item.CONTENT_ID" class="column_li">
          <lisTemplate1 :list="item" />
        </div>
      </div>
    </div>
    <div class="rightBox">
      <Rightlist />
    </div>
    <div v-show="shareImgShow==true" class="showBox">
      <div class="content">
        <div class="content_msg">
          <div class="imgBox">
            <img v-if="contentData.album.ALBUM_COVER" :src="contentData.album.ALBUM_COVER" alt="">
            <img v-else :src="noIMG" alt="">
          </div>
          <div class="title">
            {{ contentData.album.ALBUM_NAME }}
          </div>
          <p>{{ contentData.album.ALBUM_ABSTRACT }}</p>
          <div class="content_foot">
            <div class="logo_img">
              <img :src="logoImage" alt="">
            </div>
            <div id="qrcode6" ref="qrcode6" />
          </div>
        </div>
        <div class="closeBtn" @click="handelClose">
          X
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Rightlist from '@/components/commonRightList'
import Mulu from '@/components/mulu/index.vue'
import { InterestedHome, addReadSize_album, addaollect_album } from '@/api/api.js'
import lisTemplate1 from '@/components/centerlist_home/listTemplate1/index.vue'
import tuijianBook from '@/views/components/sourceDetail_content/tuijianBookContent/index.vue'
import { ssoUserLogin } from '@/api/api.js'
export default {
  components: { Rightlist, Mulu, lisTemplate1, tuijianBook },
  head() {
    var listObj = this.$store.state.albumDetailData.album
    var metaStr = listObj.ALBUM_ABSTRACT
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: this.contentData.album.ALBUM_NAME + '-彭祖世家网_寻根问祖_家谱百科_家谱制作领导者',
      mateDesc: metaStr,
      keys: ''
    }
  },
  data() {
    return {
      noimg: require('@/static/home_noimg.png'),
      albumId: '',
      likeData: [],
      shareImgShow: false,
      logoImage: require('@/static/logo_gengji22.png')
    }
  },
  computed: {
    contentData() {
      return this.$store.state.albumDetailData
    }
  },
  asyncData({ store, route }) {
    return store.dispatch('albumDetail', { albumId: route.query.albumId })
  },
  beforeCreate() {
    this.$store.dispatch('albumDetail', { albumId: this.$route.query.albumId })
  },
  mounted() {
    ssoUserLogin().then(res => {
      if (res.data.userId) {
        this.setloca('userid', res.data.userId, 7200)
        localStorage.removeItem('unionid')
      } else {
        localStorage.removeItem('userid')
      }
    })
    this.albumId = this.$route.query.albumId
    this.$nextTick(function() {
      if (this.$route.query.albumId) {
        addReadSize_album({ albumId: this.$route.query.albumId }).then(res => {

        })
      }
    })
    this.wx()
    this.wx2()
    InterestedHome().then(res => {
      this.likeData = res.data
    })
    window.addEventListener('beforeunload', this.fn)
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.fn)
  },
  methods: {
    wx2: function() {
      const qrcode6 = new QRCode('qrcode6', {
        text: window.location.href,
        width: 100,
        height: 100,
        colorDark: '#000', // 黑色
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H
      })
      qrcode6.makeCode(window.location.href)// 生成另一个新的二维码
    },
    handelClose: function() {
      this.shareImgShow = false
    },
    shareImg: function() {
      this.shareImgShow = true
    },
    fn: function() {
      window.scrollTo(0, 0)
    },
    weibo: function() {
      var p = {
        count: '1',
        url: window.location.href,
        // 用于发布微博的来源显示， 为空则分享的内容来源会显示来自互联网。(可选， 允许为空)
        appkey: '彭祖世家网',
        // 分享时所示的文字内容， 为空则自动抓取分享页面的title值(可选， 允许为空)
        title: this.contentData.album.ALBUM_TITLE,
        pic: this.contentData.album.ALBUM_COVER,
        ralateUid: '',
        language: 'zh_cn'
      }
      var s = []
      for (var i in p) {
        s.push(i + '=' + encodeURIComponent(p[i] || ''))
      }
      var url = 'http://service.weibo.com/share/share.php?' + s.join('&')
      window.open(url, '_blank')
    },
    qq: function() {
      var p = {
        /* 获取URL，可加上来自分享到QQ标识，方便统计*/
        url: window.location.href,
        desc: '彭祖世家网',
        /* 分享标题(可选)*/
        title: this.contentData.album.ALBUM_TITLE,
        /* 分享摘要(可选)*/
        summary: this.contentData.album.ALBUM_ABSTRACT,
        /* 分享图片(可选)*/
        pics: this.contentData.album.ALBUM_COVER,
        /* 视频地址(可选)*/
        flash: '',
        /* 分享来源(可选) 如：QQ分享*/
        site: '彭祖世家网',
        style: '201',
        width: 32,
        height: 32
      }
      var s = []
      for (var i in p) {
        s.push(i + '=' + encodeURIComponent(p[i] || ''))
      }
      var url = 'http://connect.qq.com/widget/shareqq/index.html?' + s.join('&')
      window.open(url, '_blank')
    },
    wx: function() {
      const qrcode = new QRCode('qrcode', {
        text: window.location.href,
        width: 100,
        height: 100,
        colorDark: '#000', // 黑色
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H
      })
      // if (this.$refs.qrcode.innerHTML) {
      //   this.$refs.qrcode.innerHTML = ''
      // }
      // qrcode.makeCode(window.location.href)// 生成另一个新的二维码
    },
    goread(firstmuluIndex, childmuluIndex) {
      if (this.contentData.contentNumber == 0) {
        this.$message({
          message: '暂无内容',
          type: 'warning'
        })
      } else {
        this.$router.push({ path: '/albumDetailRead', query: { 'firstmuluIndex': firstmuluIndex, 'childmuluIndex': childmuluIndex, 'albumId': this.$route.query.albumId }})
      }
    },
    goshowcang: function() {
      if (this.getLoca('userid')) {
        var obj = {}
        obj.userId = this.getLoca('userid')
        obj.albumId = this.$route.query.albumId
        addaollect_album(obj).then(res => {
          if (res.data == true) {
            if (this.contentData.collectionNOrNot) {
              this.$message({
                message: '取消收藏成功',
                type: 'success'
              })
              this.contentData.album.COL_COUNT = this.contentData.album.COL_COUNT - 1
            } else {
              this.$message({
                message: '收藏成功',
                type: 'success'
              })
              this.contentData.album.COL_COUNT = this.contentData.album.COL_COUNT * 1 + 1
            }
            this.contentData.collectionNOrNot = !this.contentData.collectionNOrNot
          }
        })
      } else {
        this.$router.push({ path: '/login' })
      }
    },
    goablum: function() {
      this.$router.push({ path: '/album' })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .icon2{
    cursor: pointer;
  }
  .tuijian{
    padding-left: 20px;
    padding-bottom: 20px;
    margin: 20px 0;
    background-color: #fff;
    padding-top: 20px;
    .Booktitle{
      margin-bottom: 20px;
      padding-bottom: 5px;
      border-bottom: 2px solid #e5e5e5;
      span{
        display: inline-block;
        padding-left: 7px;
        height: 20px;
        border-left: 2px solid #ed4040;
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
  .showBox{
    position: fixed;
    width: 100%;
    height: 100vw;
    background-color: rgba(0,0,0,.3);
    z-index: 15;
    display: block;
    top: 0;
    left: 0;
    .content{
      background-color: #fff;
      width: 432px;
      height: 630px;
      margin: 0 auto;
      margin-top: 30px;
      position: relative;
      .content_msg{
        overflow: hidden;
        .imgBox{
          width: 432px;
          height: 268px;
          font-size: 0;
          img{
            width: 432px;
            height: 268px;
          }
        }
        .title{
          font-size: 27px;
          color: #333333;
          font-weight: 500;
          text-align: center;
          margin:20px 0;
        }
        p{
          display:-webkit-box;
          -webkit-line-clamp:3;
          -webkit-box-orient:vertical;
          overflow:hidden;
          word-break: break-all;
          padding: 0 20px;
          font-size: 18px;
          color: #a19d9e;
          line-height: 25px;
          height: 75px;
          margin-bottom: 20px;
          text-align: center;
        }
        .content_foot{
          border-top: 1px dashed #a19d9e;
          padding-top: 20px;
          font-size: 0;
          .logo_img{
            width: 173px;
            height: 56px;
            display: inline-block;
            vertical-align: top;
            margin-right: 86px;
            margin-top: 30px;
            margin-left: 29px;
          }
        }
      }
      .closeBtn{
        position: absolute;
        bottom: -25px;
        left: 191px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #ffffff;
        line-height: 50px;
        text-align: center;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
  #qrcode6{
    display: inline-block;
  }
  .moreShare{
    display: inline-block!important;
    vertical-align: top;
    height: 50px;
    line-height: 50px;
    a{
      background-image: none;
      margin-top: 8px;
      color: #ccc;
      font-size:18px;
    }
  }
  .collected {
    svg {
      color: #ed4040;
    }
  }
  .nocollected {
    svg {
      color: #ccc;
    }
  }
  .wxImg{
    position: relative;
    &:hover > #qrcode{
      display: inline-block;
      top: -105px;
      left:-50px;
    }
  }
  #qrcode{
    top: -105px;
    display: none;
    position: absolute;
    width: 100px;
    height: 100px;
    overflow: hidden;
  }
  .newsBox{
    background-color: #fafafa;
    overflow: hidden;
    position: relative;
  }
  .leftBox{
    width: 880px;
    margin-right: 20px;
    margin-top: 20px;
    float: left;
    .topBox{
      height: 40px;
      line-height: 40px;
      border: 1px solid #e5e5e5;
      padding-left: 10px;
      color: #808080;
      background-color: #fff;
      margin-bottom: 20px;
      .albums{
        color: #ed4040;
        cursor: pointer;
        margin-right: 5px;
      }
      .albums_name{
        margin-left: 3px;
      }
    }
    .topmsg{
      height: 310px;
      border: 1px solid #e5e5e5;
      padding-left: 20px;
      color: #808080;
      background-color: #fff;
      margin-bottom: 20px;
      .imgBox{
        width: 200px;
        height: 280px;
        display: inline-block;
        margin-top: 10px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .msg_rightBox{
        height: 260px;
        width: 640px;
        display: inline-block;
        vertical-align: top;
        margin-top: 10px;
        padding-left: 16px;
        h5{
          height: 40px;
          line-height: 40px;
          width: 100%;
          font-size: 18px;
          color: #333333;
        }
        p{
          height: 30px;
          line-height: 30px;
          font-size: 16px;
          color: #666666;
        }
        .msg_rightBox_span{
          display: block;
          width: 100%;
          height: 30px;
          line-height: 30px;
          font-size: 15px;
          color: #666666;
        }
        .abstract{
          height: 40px;
          line-height: 20px;
          display:-webkit-box;
          -webkit-line-clamp:2;
          -webkit-box-orient:vertical;
          overflow:hidden;
          word-break: break-all;
        }
        .shareBox{
          height: 36px;
          line-height:36px;
            margin-top: 10px;
          .starBtn{
            display: inline-block;
            height: 36px;
            width: 138px;
            background-color: #ed4040;
            font-size: 13px;
            text-align: center;
            line-height: 36px;
            color: #ffffff;
            cursor: pointer;
            border-radius: 3px;
          }
          span{
            display: inline-block;
            color: #cccccc;
            margin-left: 20px;
            &:hover{
              color: #ed4040;
            }
            svg{
              font-size: 18px;
              cursor: pointer;
              &:hover{
                color: #ed4040;
              }
            }
            i{
              font-size: 18px;
              cursor: pointer;
              &:hover{
                color: #ed4040;
              }
            }
          }
          .num{
            margin-left: 5px;
          }
        }
        .foot_msg{
          margin-top: 23px;
          height: 30px;
          line-height: 30px;
          .foot_msg_span{
            display: inline-block;
            margin-right: 50px;
            svg{
              margin-right: 5px;
            }
          }
        }
      }
    }
    ///公用name
    .topname{
      height: 25px;
      padding-bottom: 10px;
      border-bottom:1px solid #e5e5e5;
      margin-top: 20px;
      margin-bottom: 10px;
      span{
        padding-left: 9px;
        display: inline-block;
        border-left: 2px solid #ed4040;
        color: #4d4d4d;
        font-weight: 700;
      }
    }
    .muluBox{
      background-color: #fff;
      padding-left: 20px;
      overflow: hidden;
      padding-bottom: 40px;
    }
    .youlike{
      display: none;
      padding-left: 20px;
      overflow: hidden;
      .column_li{
        /*width: 410px;*/
        /*height: 230px;*/
        /*display: inline-block;*/
        /*float: left;*/
        /*background-color: #fff;*/
        /*!*margin-left: 20px;*!*/
        /*margin-bottom: 20px;*/
        display: inline-block;
        margin-left: 20px;
        margin-top: 20px;
        width: 275px;
        height: 278px;
        margin-left: 60px;
      }
    }
  }
  .rightBox{
    width: 300px;
    margin-top: 20px;
    float: right;
    overflow: hidden;
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .leftBox{
      width: 100%;
      margin-top: 0;
      .bannerBox{
        width: 100%;
        height: auto;
      }
      .topmsg{
        .imgBox{
          width: 126px;
          height: 200px;
          img{

          }
        }
        .msg_rightBox{
          width: calc( 100vw - 180px );
          position: relative;
          h5{
            font-size: 16px;
            height: 32px;
            line-height: 32px;
          }
          .msg_rightBox_span{
            font-size: 14px;
            height: 28px;
            line-height: 28px;
          }
          .abstract{
            height: 78px;
          }
          .foot_msg {
            margin-top: 0;
            position: absolute;
            bottom: -14px;
            left: 37px;
            .foot_msg_span{
              margin-right: 7px;
            }
          }
          .shareBox{
            position: absolute;
            bottom: -18px;
            left: -125px;
            text-align: center;
            .phoneHideBOx{
              display: none;
            }
            .starBtn{
              width: 100px;
            }
          }
        }
      }
    }
    .rightBox{
      display: none;
    }
    .leftBox .topmsg .msg_rightBox p{
      font-size: 14px;
    }
    .nocollected{
      svg{
        color: #808080;
      }
    }
    .leftBox .topmsg .msg_rightBox .shareBox span svg{
      font-size: 16px;
    }
  }
</style>
